import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    submitFailed: {
        id: '_.connect_open_banking.submit_failed',
        defaultMessage: 'Please link your business account or upload statements'
    }
});
